module.exports = __webpack_public_path__ + "img/SubAccount.ba4a41e9.svg";